// src/pages/auth/CheckEmail.tsx
import React from "react";
import { Link } from "react-router-dom";
import { Mail, CheckCircle2, Clock } from "lucide-react";
import { useAppSelector } from "../../app/hooks";

const CheckEmail: React.FC = () => {
  const { user } = useAppSelector((s) => s.auth);

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-md w-full space-y-8">
        <div className="text-center">
          <div className="mx-auto w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mb-4">
            <Mail size={32} className="text-green-600" />
          </div>
          <h2 className="text-3xl font-bold text-gray-900">Check your email</h2>
          <p className="mt-2 text-sm text-gray-600">
            We've sent a verification link to
          </p>
          {user?.email && (
            <p className="mt-1 text-sm font-medium text-gray-900">
              {user.email}
            </p>
          )}
        </div>

        <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6 space-y-4">
          <div className="space-y-3">
            <div className="flex items-start gap-3 text-sm text-gray-600">
              <CheckCircle2
                size={20}
                className="text-green-600 flex-shrink-0 mt-0.5"
              />
              <div>
                <p className="font-medium text-gray-900">
                  Click the verification link
                </p>
                <p>Open your email and click the link to verify your account</p>
              </div>
            </div>

            <div className="flex items-start gap-3 text-sm text-gray-600">
              <Clock
                size={20}
                className="text-green-600 flex-shrink-0 mt-0.5"
              />
              <div>
                <p className="font-medium text-gray-900">
                  Link expires in 24 hours
                </p>
                <p>Make sure to verify your email within this time</p>
              </div>
            </div>
          </div>

          <div className="pt-4 border-t">
            <p className="text-xs text-gray-500 text-center mb-3">
              Didn't receive the email? Check your spam folder
            </p>
            <div className="space-y-2">
              <Link
                to="/user/dashboard"
                className="w-full flex items-center justify-center gap-2 bg-green-500 text-white py-2.5 px-4 rounded-lg font-medium hover:bg-green-600 focus:outline-none focus:ring-2 focus:ring-green-500 focus:ring-offset-2 transition-colors"
              >
                Go to Dashboard
              </Link>
              <Link
                to="/login"
                className="w-full flex items-center justify-center gap-2 bg-white text-gray-700 py-2.5 px-4 rounded-lg font-medium border border-gray-300 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-green-500 focus:ring-offset-2 transition-colors"
              >
                Back to Login
              </Link>
            </div>
          </div>
        </div>

        <div className="bg-blue-50 border border-blue-200 rounded-lg p-4">
          <p className="text-sm text-blue-800">
            <span className="font-medium">Note:</span> You can still access your
            dashboard, but some features may be limited until you verify your
            email address.
          </p>
        </div>
      </div>
    </div>
  );
};

export default CheckEmail;
